<template>
  <div>
    <div> 
        <b-button v-b-toggle="'list-invisible-filterjobs'" class="m-1" variant="info">
          <span class="when-open"
            ><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span
          >
          <span class="when-closed"
            ><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span
          >
          {{ $t("connector.label.list_filter_job") }}
        </b-button>
        <b-collapse v-model="listVisible" id="list-invisible-filterjobs">
          <b-table
            :fields="fields"
            :items="filterJobs"
            small
            responsive="sm"
            :tbody-tr-class="rowClass"
          >
            <template #cell(Id)="row">
              <b-col>{{ row.item.Id }}</b-col>
            </template>
            <template #cell(Libelle)="row">
              <b-col>{{ row.item.Name }}</b-col>
            </template>
            <template #cell(Include)="row">
              <b-col>
                <b-form-checkbox
                  switch
                  v-model="row.item.Include"
                  @input="updateFilterJob($event,row.item)"
                ></b-form-checkbox>
              </b-col>
            </template>
          </b-table>
        </b-collapse>
      </div>
    </div>
</template>

<script>
export default {
  name: "FilterJobs",

  props: {
    jobs: {
      type: Array,
      default: null,
    }
  },
  data() {
    return {
      title: "List des métiers inclus",
      fields: [
        {
          Id: {
            label: "Id",
            sortable: true,
            tdClass: "align-middle text-right",
          },
        },
        {
          Name: {
            label: "Libellé",
            sortable: true,
            tdClass: "align-middle text-left",
          },
        },
        {
          Include: {
            label: "Inclus",
            sortable: true,
            tdClass: "align-middle",
          },
        },
 
      ],
      loading: true,
      listVisible: false,
      filterJobs: null
    };
  },
  mounted() {
    this.filterJobs = this.jobs;
    this.listVisible = !!this.filterJobs;
  },
  methods: {
    rowClass(item, type) {
      // Force en string car différent selon la source
      if (!item || type !== "row") return;
      if (!item.Include) return "gosted";
    },
    updateFilterJob(value, item){
      this.$emit("update-filter-job", item)
    }
  },
};
</script>
<style>
.deleted {
  font-size: 20px;
  color: rgb(92, 16, 16);
}
.gosted {
  color: grey;
  background-color: lightgray;
}
.uncompleted {
  color: red;
  background-color: rgb(247, 222, 222);
}
</style>
